import { RootState } from '../../app/store';

export const selectUserLogged = (state: RootState) => state.common.user.userLogged;

export const selectToken = (state: RootState) => state.common.user.userLogged?.token;

export const selectRole = (state: RootState) => state.common.user.userLogged?.group.code;

export const selectErrorCode = (state: RootState) => state.common.errorCode;

export const selectSession = (state: RootState) => state.common.session;

export const selectIdpProvider = (state: RootState) => state.common.idpProvider;

export const selectIdpBearer = (state: RootState) => state.common.idpBearer;

export const selectIdpCandidates = (state: RootState) => state.common.idpCandidates;

export const selectOpenCommonModal = (state: RootState) => state.common.openCommonModal;

export const selectSms = (state: RootState) => state.common.sms;

export const selectTokenPatient = (state: RootState) => state.common.tokenPatient;

export const selectOpenRelationship = (state: RootState) => state.common.openRelationshipSelected;

export const selectRelationshipsSelected = (state: RootState) => state.common.relationshipSelected;

export const selectSacInfo = (state: RootState) => state.common.user.sacInfo;

/**
 * Rol BILLING: personal propio que solo usa la facturación (FACTURACION_MODULO_SPEC.md, 9.1). Solo ve esa sección:
 * ni menú, ni rutas, ni cargas del resto de la plataforma, ni SAC.
 */
export const BILLING_ACCESS = 'BILLING';
export const BILLING_HOME = '/billing';

export const selectIsBillingOnly = (state: RootState) => state.common.user.userLogged?.access === BILLING_ACCESS;

/**
 * Rol INSTALLER: técnico de instalación, con cola de alarmas y una ficha de usuario parcial (datos personales, servicio
 * y dispositivos). gdp-api no le abre los datos de salud del usuario, su última localización, el histórico de cambios
 * de la ficha, las opciones para cambiar el tipo de servicio ni las notificaciones de profesionales, y el front no se
 * los pide: cada petición denegada deja un errorCode 101 en ERROR_LOG. Si se le abre alguno, quitar aquí su condición.
 */
export const INSTALLER_ACCESS = 'INSTALLER';

export const selectIsInstaller = (state: RootState) => state.common.user.userLogged?.access === INSTALLER_ACCESS;

// Las notificaciones de profesionales (el contador de la cabecera): gdp-api se las niega a BILLING y a INSTALLER.
export const selectHasProfessionalNotifications = (state: RootState) => {
  const access = state.common.user.userLogged?.access;
  return !!access && access !== BILLING_ACCESS && access !== INSTALLER_ACCESS;
};

// El personal de facturación no atiende alarmas aunque su grupo tenga SAC (gdp-api tampoco le abre sesión en él).
export const selectHasSac = (state: RootState) =>
  state.common.user.userLogged?.group?.hasSac === true && state.common.user.userLogged?.access !== BILLING_ACCESS;

// Niveles de access que pueden ver la Consola de supervisión.
const SUPERVISOR_ACCESS = ['ADMINISTRATOR', 'SUPERADMINISTRATOR'];

// La Consola de supervisión solo se muestra si el grupo tiene SAC (hasSac) Y el
// usuario logado es ADMINISTRATOR o SUPERADMINISTRATOR.
export const selectCanSupervise = (state: RootState) =>
  state.common.user.userLogged?.group?.hasSac === true &&
  SUPERVISOR_ACCESS.includes(state.common.user.userLogged?.access);

export const selectOpenChangePasswordModal = (state: RootState) => state.common.openChangePasswordModal;

export const selectOpenEmailVerificationModal = (state: RootState) => state.common.openEmailVerificationModal;
